export default function ComplianceReport() { return <div style={{padding:28}}>Compliance Report</div>; }
